<div class="tdcf-selected-user">
    {{ i18n._7211_CURRENTLY_VIEWING_ | translate }}
    {{ selectedUserLabel || (i18n._842_N_A | translate) }}
</div>
<form
    [name]="form.name"
    [formGroup]="form.form"
>
    <div class="form-group">
        <ng-select
            [options]="userOpts"
            [id]="form.fields.QUERY.id"
            [placeholder]="form.fields.QUERY.placeholder | translate"
            [ariaLabel]="form.fields.QUERY.label | translate"
            [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
            [formControlName]="form.fields.QUERY.name"
        ></ng-select>
    </div>
</form>
